import { render, staticRenderFns } from "./AssessmentTasksTableReadOnly.vue?vue&type=template&id=1dc862d4&"
import script from "./AssessmentTasksTableReadOnly.vue?vue&type=script&lang=js&"
export * from "./AssessmentTasksTableReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports